<div class="container-fluid top-banner display--none" id="divTopBanner" name="divTopBanner">
    <div class="container">
        <div class="row">
            <div class="col-12 top-banner__content">
                <p>{{ topBannerMsg }}</p>
                <span class="icon-x-circle icon" (click)="closeTopBanner()"></span>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid sub-header hidden-sm">
    <div class="container">
        <div class="sub-header__contact">
            <div class="sub-header__item"><span class="icon-map-pin"></span> 69 William Street, Toronto, ON M9N 2G6</div>
            <div class="sub-header__item"><span class="icon-phone"></span>+1 (647) 949-4932</div>
            <div class="sub-header__item"><span class="icon-mail"></span>{{ enquiry_email }}</div>
        </div>
        <div class="sub-header__social">
            <a href="https://facebook.com/divineretreatcentretorontoca/" target="_blank">
                <span class="icon-facebook2"></span>
            </a>
            <a href="https://youtube.com/c/DivineRetreatCentreToronto/" target="_blank">
                <span class="icon-youtube"></span>
            </a>
            <a href="https://www.instagram.com/p/CzMQilnrzZo/" target="_blank">
                <span class="icon-instagram"></span>
            </a>
        </div>
    </div>
</div>

<nav class="navbar navbar-expand-xl" aria-label="nav bar">
    <div class="container">
        <a routerLink="/home" class="navbar-brand">
            <img [src]="env.assetsPath + '/img/drct-logo.png'" class="logo" alt="DRCT Logo" title="DRCT Logo">
        </a>

        <!-- Toggler button for offcanvas (mobile only) -->
        <button class="navbar-toggler d-xl-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Offcanvas on mobile -->
        <div class="offcanvas offcanvas-start d-xl-none" tabindex="-1" id="navbarContent" aria-labelledby="navbarContentLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="navbarContentLabel">Menu</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
                <!-- Menu Items -->
                <ul class="navbar-nav">
                    <!-- <li class="nav-item">
                        <a class="nav-link" aria-current="page" routerLink="/home">Home</a>
                    </li> -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            About Us
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="history" toggleMobileMenu>History</a></li>
                            <li><a class="dropdown-item" routerLink="priests" toggleMobileMenu>Meet Our Priests</a></li>
                            <li><a class="dropdown-item" routerLink="ministries" toggleMobileMenu>Ministries</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Prayer Services
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="schedule" toggleMobileMenu>Mass & Liturgical Schedule</a></li>
                            <li><a class="dropdown-item" routerLink="events" toggleMobileMenu>Events and Retreats</a></li>
                            <li><a class="dropdown-item" routerLink="brochure" toggleMobileMenu>Brochures</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Media
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="photo-gallery" toggleMobileMenu>Photo Gallery</a></li>
                            <li><a class="dropdown-item" routerLink="video-gallery" toggleMobileMenu>Video Gallery</a></li>
                        </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" routerLink="testimonies" toggleMobileMenu>Testimonies</a></li>
                    <li class="nav-item"><a class="nav-link" routerLink="mass-offer" toggleMobileMenu>Mass Offering</a></li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Contact Us
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="prayer-request" toggleMobileMenu>Prayer Request</a></li>
                            <li><a class="dropdown-item" routerLink="send-testimonies" toggleMobileMenu>Send Testimonies</a></li>
                            <li><a class="dropdown-item" routerLink="contact-us" toggleMobileMenu>Contact Us</a></li>
                        </ul>
                    </li>
                    <li class="nav-item donate-btn"><a class="nav-link" routerLink="donation" toggleMobileMenu>Donation</a></li>
                </ul>
            </div>
        </div>

        <!-- Desktop Menu -->
        <div class="collapse navbar-collapse d-none d-xl-flex" id="navbarContent">
            <ul class="navbar-nav">
                <!-- <li class="nav-item">
                    <a class="nav-link" aria-current="page" routerLink="/home">Home</a>
                </li> -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        About Us
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" routerLink="history">History</a></li>
                        <li><a class="dropdown-item" routerLink="priests">Meet Our Priests</a></li>
                        <li><a class="dropdown-item" routerLink="ministries">Ministries</a></li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Prayer Services
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" routerLink="schedule">Mass & Liturgical Schedule</a></li>
                        <li><a class="dropdown-item" routerLink="events">Events and Retreats</a></li>
                        <li><a class="dropdown-item" routerLink="brochure">Brochures</a></li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Media
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" routerLink="photo-gallery">Photo Gallery</a></li>
                        <li><a class="dropdown-item" routerLink="video-gallery">Video Gallery</a></li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link" routerLink="testimonies">Testimonies</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="mass-offer">Mass Offering</a></li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Contact Us
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" routerLink="prayer-request">Prayer Request</a></li>
                        <li><a class="dropdown-item" routerLink="send-testimonies">Send Testimonies</a></li>
                        <li><a class="dropdown-item" routerLink="contact-us">Contact Us</a></li>
                    </ul>
                </li>
                <li class="nav-item donate-btn"><a class="nav-link" routerLink="donation">Donation</a></li>
            </ul>
        </div>
    </div>
</nav>